import { Radio } from "lucide-react";

export default function NavBar() {
  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-40 backdrop-blur-md bg-[#12100e]/80 border-b border-[#332f2b]"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-4 flex items-center justify-between">
        <a
          href="#top"
          data-testid="logo"
          className="flex items-center gap-2.5 group"
        >
          <span className="relative w-9 h-9 rounded-full bg-[#FF6B00] flex items-center justify-center shadow-[0_0_12px_rgba(255,107,0,0.5)]">
            <Radio size={18} className="text-[#12100e]" />
          </span>
          <span className="font-anton text-xl uppercase tracking-wider text-[#F5F2EB] group-hover:text-[#FF6B00] transition-colors">
            Rumore <span className="text-[#FF6B00]">Zero</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-7 font-mono text-xs uppercase tracking-[0.2em] text-[#A39A8F]">
          <a data-testid="nav-bacheca"   href="#bacheca"   className="hover:text-[#FF6B00] transition">Bacheca</a>
          <a data-testid="nav-richieste" href="#richieste" className="hover:text-[#FF6B00] transition">Richieste</a>
          <a data-testid="nav-programmi" href="#programmi" className="hover:text-[#FF6B00] transition">Playlist</a>
          <a data-testid="nav-about"     href="#about"     className="hover:text-[#FF6B00] transition">Stazione</a>
        </nav>
      </div>
    </header>
  );
}
